module.exports = __webpack_public_path__ + "static/img/response2.d599e3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/home/response2.png
// module id = j8Mn
// module chunks = 0